export {
  default as brush,
  brushX,
  brushY,
  brushSelection
} from "./src/brush";



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-brush/index.js
// module id = ../../../../d3-brush/index.js
// module chunks = 4